import axios from "../utils/axios";

export const getAreaGroupList = (data) => {
    return axios.post(`/UnplannedMaintenance/GetAreaGroupsStatistics`, data);
};

export const getMainEquipmentList = (data) => {
    return axios.post(`/UnplannedMaintenance/GetMainEquipmentsStatistics`, data);
};

export const getSubEquipmentList = (data) => {
    return axios.post(`/UnplannedMaintenance/GetSubEquipmentsStatistics`, data);
};

export const getSubEquipmentsTaskList = (data) => {
    return axios.post(`/UnplannedMaintenance/GetTasksBySummaryFilter`, data);
};

export const getBreakdownReasonGroupData = () => {
    return axios.get(`/BreakdownReasonGroup/GetList`);
};

export const getBreakdownReasonPlaceData = () => {
    return axios.get(`/BreakdownReasonPlace/GetListWithGroup`);
};

export const getBreakdownEffectData = () => {
    return axios.get(`/BreakdownEffect/GetList`);
};

export const getBreakdownRootCauseData = () => {
    return axios.get(`/BreakdownRootCause/GetList`);
};

export const getPoolData = () => {
    return axios.get(`/Pool/GetList`);
};

